module.exports = __webpack_public_path__ + "img/note.079e45ef.png";